import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess304005Status: 'idle',
    startProcess304005Error: undefined as any,
    loadUserParamsProcess304005Status: 'idle',
    loadUserParamsProcess304005Error: undefined as any,

    process304005List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess304005 = createAsyncThunk('process304005Slice/startProcess304005', async ({ process304005 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess304005/`,
        prepareData(process304005),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess304005Status } = getState().process304005Slice
        return startProcess304005Status !== 'pending'
    }
})

export const loadUserParamsProcess304005 = createAsyncThunk('process304005Slice/loadUserParamsProcess304005', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess304005/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess304005Status } = getState().process304005Slice
        return loadUserParamsProcess304005Status !== 'pending'
    }
})

const Process304005Slice = createSlice({
    name: 'process304005Slice',
    initialState,
    reducers: {
        resetstartProcess304005: (state) => {
            state.job = undefined
            state.startProcess304005Error = undefined
        },
        resetstartProcess304005Error: (state) => {
            state.startProcess304005Error = undefined
        },
        resetloadUserParamsProcess304005: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess304005Error = undefined
        },
        resetloadUserParamsProcess304005Error: (state) => {
            state.loadUserParamsProcess304005Error = undefined
        },
        removeFromProcess304005ListById: (state, action) => {
            state.process304005List = state.process304005List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess304005ListByIds: (state, action) => {
            state.process304005List = state.process304005List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process304005List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess304005Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process304005List = []
            state.startProcess304005Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess304005.pending, (state) => {
            state.startProcess304005Status = 'pending'
            state.startProcess304005Error = undefined
        })
        builder.addCase(startProcess304005.fulfilled, (state, action) => {
            state.startProcess304005Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess304005.rejected, (state, action) => {
            state.startProcess304005Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess304005Error = action.error.message
            } else {
                state.startProcess304005Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess304005.pending, (state) => {
            state.loadUserParamsProcess304005Status = 'pending'
            state.loadUserParamsProcess304005Error = undefined
        })
        builder.addCase(loadUserParamsProcess304005.fulfilled, (state, action) => {
            state.loadUserParamsProcess304005Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess304005.rejected, (state, action) => {
            state.loadUserParamsProcess304005Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess304005Error = action.error.message
            } else {
                state.loadUserParamsProcess304005Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess304005,
    resetstartProcess304005Error,
    resetloadUserParamsProcess304005,
    resetloadUserParamsProcess304005Error,
    removeFromProcess304005ListById,
    removeFromProcess304005ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process304005Slice.actions
export default Process304005Slice.reducer
